var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back themeGreen",on:{"click":_vm.handleBack}},[_c('i',{staticClass:"el-icon-back",staticStyle:{"margin-right":"4px"}}),_c('span',[_vm._v(_vm._s(_vm.$t("public.goBack")))])])}
var staticRenderFns = []

export { render, staticRenderFns }